import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash, FaSearch } from 'react-icons/fa';
import { toast } from 'react-toastify';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  // Función simplificada para obtener productos
  const fetchProducts = async () => {
    setLoading(true);
    try {
      // Simulamos la obtención de productos para demostración
      // En un entorno real, esto se conectaría a tu backend
      
      // Creamos algunos productos de ejemplo
      const mockProducts = [
        {
          id: '1',
          name: 'Melatonina 5mg',
          categoryId: '2',
          categoryName: 'Sueño y Relajación',
          presentation: '60 cápsulas',
          price: 24.99,
          description: 'Suplemento para mejorar la calidad del sueño',
          status: 'active',
          imageUrl: 'https://example.com/melatonina.jpg'
        },
        {
          id: '2',
          name: 'Omega 3 Fish Oil',
          categoryId: '9',
          categoryName: 'Apoyo al Sistema Inmune',
          presentation: '90 cápsulas',
          price: 29.99,
          description: 'Aceite de pescado rico en ácidos grasos omega-3',
          status: 'active',
          imageUrl: 'https://example.com/omega3.jpg'
        },
        {
          id: '3',
          name: 'Magnesio Citrato',
          categoryId: '3',
          categoryName: 'Apoyo Anti-Estrés y Estado de Ánimo',
          presentation: '120 cápsulas',
          price: 19.99,
          description: 'Suplemento de magnesio para reducir el estrés y mejorar el estado de ánimo',
          status: 'active',
          imageUrl: 'https://example.com/magnesio.jpg'
        },
        {
          id: '4',
          name: 'Vitamina D3 5000 UI',
          categoryId: '9',
          categoryName: 'Apoyo al Sistema Inmune',
          presentation: '60 cápsulas',
          price: 15.99,
          description: 'Vitamina D3 para fortalecer el sistema inmunológico',
          status: 'active',
          imageUrl: 'https://example.com/vitaminad3.jpg'
        },
        {
          id: '5',
          name: 'Probiótico 50 Billones',
          categoryId: '5',
          categoryName: 'Salud Gastrointestinal y Pérdida de Peso',
          presentation: '30 cápsulas',
          price: 34.99,
          description: 'Probiótico con múltiples cepas para la salud digestiva',
          status: 'active',
          imageUrl: 'https://example.com/probiotico.jpg'
        },
        {
          id: '6',
          name: 'Ashwagandha 1300mg',
          categoryId: '3',
          categoryName: 'Apoyo Anti-Estrés y Estado de Ánimo',
          presentation: '90 cápsulas',
          price: 27.99,
          description: 'Adaptógeno para reducir el estrés y mejorar la energía',
          status: 'active',
          imageUrl: 'https://example.com/ashwagandha.jpg'
        },
        {
          id: '7',
          name: 'Colágeno Hidrolizado',
          categoryId: '10',
          categoryName: 'Piel Saludable',
          presentation: '300g polvo',
          price: 39.99,
          description: 'Colágeno para mejorar la salud de la piel, cabello y uñas',
          status: 'active',
          imageUrl: 'https://example.com/colageno.jpg'
        },
        {
          id: '8',
          name: 'Proteína Vegana',
          categoryId: '6',
          categoryName: 'Deporte y Modo de Vida Activo',
          presentation: '1kg polvo',
          price: 49.99,
          description: 'Proteína a base de plantas para deportistas',
          status: 'active',
          imageUrl: 'https://example.com/proteina.jpg'
        }
      ];
      
      // Sin retrasos artificiales para mejorar la velocidad
      
      setProducts(mockProducts);
      setError(null);
    } catch (err) {
      console.error('Error al cargar productos:', err);
      setError('No se pudieron cargar los productos. Verifica tu conexión e inténtalo de nuevo.');
      toast.error('Error al cargar productos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  
  // Función simplificada para eliminar un producto
  const deleteProduct = async (productId) => {
    try {
      // Simulamos la eliminación del producto
      // En un entorno real, esto se conectaría a tu backend
      
      // Sin retrasos artificiales para mejorar la velocidad
      
      // Actualizar la lista de productos (eliminación local)
      setProducts(products.filter(p => p.id !== productId));
      toast.success('Producto eliminado correctamente');
      setConfirmDelete(null);
    } catch (err) {
      console.error('Error al eliminar producto:', err);
      toast.error('Error al eliminar producto');
    }
  };
  
  // Filtrar productos según el término de búsqueda
  const filteredProducts = products.filter(product => 
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (product.categoryName && product.categoryName.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 mb-0">Productos</h1>
        <Link to="/admin/products/new" className="btn btn-primary">
          <FaPlus className="me-2" />
          Nuevo Producto
        </Link>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="card shadow-sm">
        <div className="card-header bg-white py-3">
          <div className="row align-items-center">
            <div className="col">
              <div className="input-group">
                <span className="input-group-text">
                  <FaSearch />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por nombre o categoría..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="d-flex justify-content-center my-5">
              <p>Cargando...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Categoría</th>
                    <th>Presentación</th>
                    <th>Precio</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        {searchTerm ? 'No se encontraron productos que coincidan con la búsqueda' : 'No hay productos registrados'}
                      </td>
                    </tr>
                  ) : (
                    filteredProducts.map(product => (
                      <tr key={product.id}>
                        <td>{product.name}</td>
                        <td>{product.categoryName}</td>
                        <td>{product.presentation}</td>
                        <td>${product.price.toFixed(2)}</td>
                        <td>
                          <span className={`badge bg-${product.status === 'active' ? 'success' : 'secondary'}`}>
                            {product.status === 'active' ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td>
                          <div className="btn-group">
                            <Link to={`/admin/products/edit/${product.id}`} className="btn btn-sm btn-outline-primary">
                              <FaEdit />
                            </Link>
                            <button 
                              className="btn btn-sm btn-outline-danger" 
                              onClick={() => setConfirmDelete(product.id)}
                              title="Eliminar producto"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal de confirmación para eliminar - simplificado sin transiciones */}
      {confirmDelete && (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmar eliminación</h5>
                <button type="button" className="btn-close" onClick={() => setConfirmDelete(null)}></button>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar este producto? Esta acción no se puede deshacer.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setConfirmDelete(null)}>Cancelar</button>
                <button type="button" className="btn btn-danger" onClick={() => deleteProduct(confirmDelete)}>Eliminar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
